import {
  AnimationComponent,
  Divider,
  GKButton,
  Grid2,
  Permission,
  PopConfirm,
  Show,
  Tab,
  Tabs,
} from "components";
import { usePartner } from "hooks/usePartner";
import { useState } from "react";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { QueryKeys } from "utils/queryKey";
import BasketTab from "./BasketTab";
import ClientTab from "./ClientTab";
import PartnerAccess from "./PartnerAccess";
import { CommissionManager } from "Pages/Revenue";

interface Props {
  id: string;
}

const DetailsTabView = (props: Props) => {
  const { id } = props;

  const dispatch = useAppDispatch();

  const { partnerDetailsPageTab } = useAppSelector((state) => state?.app?.tab);

  const { deletePartner, deletePartnerLoading } = usePartner();

  const [confirmationModal, setConfirmationModal] =
    useState<HTMLElement | null>(null);

  const tabsConfig = [
    {
      label: "Portfolios",
      component: <ClientTab id={id} />,
    },
    {
      label: "Baskets",
      component: <BasketTab id={id} />,
    },
    // {
    //   label: "Fee plan",
    //   component: <FeePlanTab />,
    // },
    // {
    //   label: "Invoices",
    //   component: (
    //     <InvoiceTab name="partnerInvoice" tableName="partner_invoice" />
    //   ),
    // },
    {
      label: "Commissions",
      component: (
        <CommissionManager
          partnerId={id}
          name="partnerCommission"
          tableName="partner_commission"
          commissionLink={`/app/revenue/commission/${id}/invoices`}
        />
      ),
    },
    {
      label: "Permissions",
      component: (
        <Permission
          headerTitle="Partner Permission"
          route={`/partner/${id}/permissions/`}
          queryKey={QueryKeys.PARTNER_PERMISSION}
          permissionType="PARTNER"
        />
      ),
    },
    {
      label: "Access",
      component: <PartnerAccess />,
    },
  ];

  const handleTabChange = (event: React.SyntheticEvent, value: number) => {
    dispatch(TAB({ tabKey: "partnerDetailsPageTab", tabValue: value }));
  };

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={10}>
        <Tabs
          value={partnerDetailsPageTab}
          onChange={handleTabChange}
          indicatorColor="primary"
        >
          {tabsConfig.map((tab, index) => (
            <Tab key={index} label={tab.label} />
          ))}
        </Tabs>
      </Grid2>
      <Show.When isTrue={partnerDetailsPageTab === 3}>
        <Grid2
          size={2}
          display={"flex"}
          justifyContent={"flex-end"}
          alignItems={"center"}
        >
          <GKButton
            variant="outlined"
            color="error"
            size="medium"
            loading={deletePartnerLoading}
            onClick={(event) => setConfirmationModal(event.currentTarget)}
          >
            Delete Partner
          </GKButton>
          <Divider />
        </Grid2>
      </Show.When>
      <Grid2 size={12}>
        {tabsConfig.map((tab, index) => (
          <Show.When key={index} isTrue={partnerDetailsPageTab === index}>
            <AnimationComponent>{tab.component}</AnimationComponent>
          </Show.When>
        ))}
      </Grid2>

      <Show.When isTrue={Boolean(confirmationModal)}>
        <PopConfirm
          anchorEl={confirmationModal}
          onSuccess={() => deletePartner(id)}
          open={Boolean(confirmationModal)}
          setOpen={setConfirmationModal}
        />
      </Show.When>
    </Grid2>
  );
};

export default DetailsTabView;
